import { useWebsiteSettings } from '../../hooks/useWebsiteSettings';

const PublicFooter = () => {
    const { settings } = useWebsiteSettings();

    return (
        <footer className="public-footer">
            <div className="mx-auto max-w-6xl px-4 py-8 sm:px-6">
                <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                    <div>
                        <p className="text-sm font-medium text-ink dark:text-white">
                            {settings.institutionName}
                        </p>
                        <p className="mt-1 text-sm text-muted">{settings.systemTitle}</p>
                    </div>
                    <p className="text-sm text-muted">{settings.footerText}</p>
                </div>
            </div>
        </footer>
    );
};

export default PublicFooter;
